var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('section', {
    staticClass: "hero"
  }, [_c('div', {
    staticClass: "hero-body"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title"
  }, [_vm._v("\n          " + _vm._s(_vm.heading) + "\n        ")]), _vm._v(" "), _c('div', {
    staticClass: "is-two-thirds column is-paddingless"
  })])])]), _vm._v(" "), _c('section', {
    staticClass: "section"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "columns pd is-multiline is-desktop"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "column is-two-thirds-desktop"
  }, [_c('div', {
    staticClass: "card schedule"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Schedule of events")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_vm._v("Tuesday, 14th of November, 2017")]), _vm._v(" "), _c('ul', {
    staticClass: "subtitle is-vcentered"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("9.30 am - 3.30 pm:")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "isa"
    }
  }, [_vm._v("ISA short course \"Imprecise Probability - A Gentle Overview\"")]), _vm._v(" by "), _c('a', {
    attrs: {
      "href": "http://www.eeecs.qub.ac.uk/~c.decampos/",
      "target": "_blank"
    }
  }, [_vm._v("Cassio P. de Campos")]), _vm._v(" (Queen's University Belfast) and "), _c('a', {
    attrs: {
      "href": "http://people.idsia.ch/~alessandro/",
      "target": "_blank"
    }
  }, [_vm._v("Alessandro Antonucci")]), _vm._v(" (Swiss AI Lab IDSIA)")], 1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _vm._m(6), _vm._v(" "), _vm._m(7)])])])])])])])
}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "columns pd is-desktop"
  }, [_c('div', {
    staticClass: "column is-one-third-desktop"
  }, [_c('p', {
    staticClass: "title"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/trinity-stacked.jpg"),
      "alt": "TCD"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "column is-half-desktop info"
  }, [_c('p', [_vm._v("\n            The "), _c('a', {
    attrs: {
      "href": "https://www.scss.tcd.ie/disciplines/statistics/",
      "target": "_blank"
    }
  }, [_vm._v("Discipline of Statistics")]), _vm._v(" (formerly Department of Statistics) at "), _c('a', {
    attrs: {
      "href": "www.tcd.ie",
      "target": "_blank"
    }
  }, [_vm._v("Trinity College Dublin")]), _vm._v(" is celebrating its 50th year in 2017. This special milestone will be marked by the organisation of an ISA short course and an afternoon of talks, followed by a reception, on Tuesday 14th November.\n          ")]), _vm._v(" "), _c('p', [_vm._v("If you have had a connection to the Department/Discipline in the past as a member of staff, visitor, student or other and would like to receive an RSVP invitation to this event, contact "), _c('a', {
    attrs: {
      "href": "mailto:wyseja@tcd.ie"
    }
  }, [_vm._v("wyseja@tcd.ie")]), _vm._v(".")])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column is-one-third-desktop"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Venue of the event")]), _vm._v(" "), _c('p', {
    staticClass: "subtitle"
  }, [_c('i', {
    staticClass: "fa fa-map-marker",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://www.google.ie/maps/place/O'Callaghan+Mont+Clare+Hotel/@53.3414972,-6.2530017,17z/data=!3m1!4b1!4m5!3m4!1s0x48670e90db4a8129:0xcf06339f781c38e2!8m2!3d53.341494!4d-6.250813",
      "target": "_blank"
    }
  }, [_vm._v("\n                O'Callaghan Mont Clare Hotel"), _c('br'), _vm._v("\n                1-4 Merrion Street Lower, Dublin 2\n              ")])])])]), _vm._v(" "), _c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('h2', {
    staticClass: "title"
  }, [_vm._v("Local organising committee")]), _vm._v(" "), _c('ul', {
    staticClass: "subtitle is-vcentered"
  }, [_c('li', [_c('i', {
    staticClass: "fa fa-user-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('a', {
    attrs: {
      "href": "https://www.scss.tcd.ie/Brett.Houlding/Home.html",
      "target": "_blank"
    }
  }, [_vm._v("Brett Houlding")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-user-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('a', {
    attrs: {
      "href": "http://www.bernardonipoti.com/",
      "target": "_blank"
    }
  }, [_vm._v("Bernardo Nipoti")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-user-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('a', {
    attrs: {
      "href": "http://people.tcd.ie/Profile?Username=moregan",
      "target": "_blank"
    }
  }, [_vm._v("Myra O’Regan")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-user-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('a', {
    attrs: {
      "href": "https://www.scss.tcd.ie/~arwhite/",
      "target": "_blank"
    }
  }, [_vm._v("Arthur White")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-user-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('a', {
    attrs: {
      "href": "https://www.scss.tcd.ie/disciplines/statistics/statica/statica_web/Wilson.html",
      "target": "_blank"
    }
  }, [_vm._v("Simon Wilson")])]), _vm._v(" "), _c('li', [_c('i', {
    staticClass: "fa fa-user-circle",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('a', {
    attrs: {
      "href": "https://sites.google.com/site/jsnwyse/",
      "target": "_blank"
    }
  }, [_vm._v("Jason Wyse")])])])])])])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("4:00 pm:")]), _vm._v(" Welcome (Prof. Simon Wilson)")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("4:05 pm:")]), _vm._v(" A look at the history of the department (Dr. Michael Stuart)")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("4:20 pm:")]), _vm._v(" Discussion and reminisce with former members of the Statistics Department")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("4:50 pm:")]), _vm._v(" Panel discussion on the future of and opportunities for statistics at Trinity College, in Ireland and beyond - Panel members: Prof. Adrian Raftery (University of Washington), Dr. Chris Sibley (Central Statistics Office), Mr. Kieran Towey (Accenture Advanced Analytics), Prof. Nial Friel (University College Dublin)")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("5:40 pm:")]), _vm._v(" Close and walk over to the "), _c('a', {
    attrs: {
      "href": "https://www.tcd.ie/Maps/map.php?b=194",
      "target": "_blank"
    }
  }, [_vm._v("O’Reilly Institute")]), _vm._v(" foyer for buffet and wine reception")])
},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('i', {
    staticClass: "fa fa-clock-o",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('span', [_vm._v("6.00 pm:")]), _vm._v(" Reception at the "), _c('a', {
    attrs: {
      "href": "https://www.tcd.ie/Maps/map.php?b=194",
      "target": "_blank"
    }
  }, [_vm._v("O’Reilly Institute")]), _vm._v(" foyer")])
}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ae93e884","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = iCKH
// module chunks = 0